import { render, staticRenderFns } from "./oxygen.vue?vue&type=template&id=4de77f63&scoped=true"
import script from "./oxygen.vue?vue&type=script&lang=js"
export * from "./oxygen.vue?vue&type=script&lang=js"
import style0 from "./oxygen.vue?vue&type=style&index=0&id=4de77f63&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de77f63",
  null
  
)

export default component.exports